<div class="setup-multi-factor" artemisThemeSwitcher>
  <div class="go-back" (click)="goBack()">
    <img src="/assets/icons/arrow-left-icon.svg" class="go-back__img">
    <span class="go-back__text">Go back</span>
  </div>
  <div class="setup-multi-factor__container">
    <img src="/assets/images/logo-large.png" class="logo">
    <div class="setup-multi-factor__header">
      Setup Multi-factor Authentication
    </div>
    <artemis-loading-spinner *ngIf="(loading$ | async) || !secretCode"></artemis-loading-spinner>
    <ng-container *ngIf="secretCode">
      <div class="setup-multi-factor__content">
        <form class="setup-multi-factor__form" (ngSubmit)="mfaConfirm()" [formGroup]="mfaSetupForm">
          <img class="setup-multi-factor__qrcode-image" [src]="qrcodeImg" *ngIf="qrcodeImg">
          <div class="setup-multi-factor__qrcode-container">
            <span class="setup-multi-factor__hint"> {{ 'account_setting.message.twofa' | translate }} </span>
            <mat-form-field class="custom-mat-form-field setup-multi-factor__field">
              <input matInput placeholder="{{ 'account_setting.form.label.otp_code' | translate }}" formControlName="code">
              <mat-error *ngIf="showFormControlErrors(mfaSetupForm, 'code')">
                <span *ngIf="mfaSetupForm.get('code').errors?.required">{{ 'account_setting.error' | translate }}</span>
                <span *ngIf="mfaSetupForm.get('code').errors?.pattern">{{ 'account_setting.errors' | translate }}</span>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="secret-wrapper">
            <input matInput class="secret-wrapper__input" type="text" [value]="secretCode">
            <a class="secret-wrapper__icon" (click)="copySecretCode()">
              <img class="file-icon themified-white-icon" src="/assets/icons/file_copy.png">
            </a>
          </div>
          <div class="setup-multi-factor__action">
            <button mat-button type="submit" mat-button class="btn btn_accent-gradient-rounded btn-verify" ubi-round-button [disabled]="mfaSetupForm.invalid">
              Verify
            </button>
          </div>
        </form>
      </div>
    </ng-container>
  </div>
</div>
